import React from "react";
import { useAuth } from "@/context/AuthContext";
import AccessDenied from "@/pages/AccessDenied";

export default function RequirePerm({ perm, anyOf, superOnly, children }) {
  const { can, canAny, isSuper } = useAuth();
  const ok = superOnly ? isSuper : anyOf ? canAny(anyOf) : can(perm);
  if (!ok) return <AccessDenied />;
  return children;
}
